/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OnboardingRedirectEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const onboardingRedirectEntryPoint: EntryPoint<OnboardingRedirectEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<OnboardingRedirectEntryPointComponent>(
			/* webpackChunkName: "async-onboarding-redirect-entrypoint" */ './OnboardingRedirect.tsx',
			{
				// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
				includeInShellOnlySsrBundle: true,
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
